import React from 'react';
import StreamingFeatureHost from './index';

/**
 * SDKAppWrapper - Wrapper component to make StreamingFeatureHost work as an app component
 * 
 * This component adapts StreamingFeatureHost to work with the AppLauncher window system.
 * It receives props in the app format and converts them to StreamingFeatureHost props.
 * 
 * @param {Object} props - App component props
 * @param {Object} props.metadata - App metadata containing bundleUrl
 * @param {string} props.windowId - Window ID (unused but provided by window system)
 */
export function SDKAppWrapper({ metadata, windowId, ...otherProps }) {
  const { bundleUrl, title } = metadata || {};
  
  if (!bundleUrl) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-red-400">Error: bundleUrl is required in metadata</div>
      </div>
    );
  }

  // StreamingFeatureHost will handle window/fullscreen mode automatically
  // Don't pass onClose here - the window system handles closing via window controls
  return (
    <StreamingFeatureHost
      bundleUrl={bundleUrl}
      title={title || 'SDK'}
      onClose={() => {}} // Window system handles closing
      position={{ x: 100, y: 100 }}
      size={{ width: 1400, height: 900 }}
      windowProps={{ embedded: true }} // Indicates it's embedded in window system
    />
  );
}

export default SDKAppWrapper;

